import { saveAs } from 'file-saver'
import { useCallback } from 'react'

export const useSaveFile = () => {
    return useCallback((blob: Blob, filename: string) => {
        saveAs(blob, filename, { autoBom: true })
    }, [])
}
